import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './form-fields.module.css';

interface CheckBoxProps {
    id: string;
    label: JSX.Element;
    name: string;
    checkedByDefault?: boolean;
    handler?: (checked: boolean) => void;
    required?: boolean;
}

const CheckBoxWithJSXLabel: React.FC<CheckBoxProps> = ({
    id,
    label,
    name,
    checkedByDefault = false,
    handler,
    required = false,
}) => {
    const { t } = useTranslation(['common']);
    const [checked, toggleChecked] = React.useState<boolean>(checkedByDefault);

    const handleChange = (): void => {
        if (handler) {
            handler(!checked);
        }

        toggleChecked(!checked);
    };

    return (
        <div className={styles.CheckBox}>
            <input
                checked={checked}
                id={id}
                name={name}
                type="checkbox"
                onChange={handleChange}
                value={checked ? 'true' : 'false'}
            />
            <label className={styles.CheckboxLabel} htmlFor={id}>
                {label}
                {required ? ` (${t('common:required')})` : ''}
            </label>
        </div>
    );
};

export default CheckBoxWithJSXLabel;
